import { Component,Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-dialog-create-folder',
  templateUrl: './dialog-create-folder.component.html',
  styleUrls: ['./dialog-create-folder.component.scss']
})
export class DialogCreateFolderComponent {

  @Input() folder:any;
  @Input() isCreate:boolean = true;
  
  constructor(
    protected ref: NbDialogRef<DialogCreateFolderComponent>) {}

  id:string;
  pattern = new RegExp('^[a-zA-Z0-9-+@#$_.&! ]*$');
  folderForm = new FormGroup({

    folderName : new FormControl(null, [
      Validators.required,
      Validators.maxLength(80),
      Validators.pattern(this.pattern),
    ]),
    tag: new FormControl(null,[Validators.maxLength(15)]),
    description:  new FormControl(null,[Validators.maxLength(500)])
  });


  ngOnInit(){
    if(this.folder != undefined){
      this.id = this.folder.id;
      this.folderForm.get('folderName').setValue(this.folder.name);
      this.folderForm.get('tag').setValue(this.folder.tag);
      this.folderForm.get('description').setValue(this.folder.description);
    }
  }

  get folderName() {
    return this.folderForm.get('folderName');
  }

  saveFolderName(){
    const folderName = this.folderForm.get('folderName').value;
    const tag = this.folderForm.get('tag').value;
    const description =this.folderForm.get('description').value;

    this.ref.close({
      id : this.id,
      folderName,
      tag,
      description
    });
  }

  cancel(){
    this.ref.close();
  }
}
